import { FC, ReactNode } from 'react';
import MobileTableRow from './Row';
import './MobileTable.scss';
import { DesktopTableProps } from '../Desktop/DesktopTable';

export type MobileTableProps = DesktopTableProps & {
  mobileMainContent: (row) => ReactNode;
  mobileBottomColumn: (row) => ReactNode;
};

const MobileTable: FC<MobileTableProps> = ({
  tableProps,
  data,
  ...otherProps
}) => {
  const { className, ...restProps } = tableProps ?? {};

  return (
    <div className={`${className} mobile-table`} {...restProps}>
      {data.map((row, index) => (
        <MobileTableRow key={index} row={row} {...otherProps} />
      ))}
    </div>
  );
};

export default MobileTable;
